import { UserRoleType } from 'common/constants';
import { FastApiAxiosInstance } from 'common/service/axiosInstances';
import { TaskScene, ExternalCreateTaskPayload, ParentTask, RequirementType } from 'common/types';

// 父任务角色人员（用于反馈 @ 提及候选人）
export interface ParentTaskRoleUser {
  userId: number;
  nickName?: string;
  name?: string;
  fullName?: string;
  avatar?: string;
  email?: string;
  corpEmail?: string;
  roles: string[];
}

const taskV2 = {
  // 获取需求场景，包含场景下的类型
  getTaskSceneList: () => {
    return FastApiAxiosInstance.get<{ total: number; items: TaskScene[] }>('/api/v2/task/requirement/scene');
  },
  getRequirementList: () => {
    return FastApiAxiosInstance.get<{ total: number; items: RequirementType[] }>('/api/v2/task/requirement/list');
  },
  // 创建需求
  createTask: (params: ExternalCreateTaskPayload) => {
    return FastApiAxiosInstance.post<{ parentTaskId: number }>('/api/v2/task/create', params);
  },
  // 新版获取任务详情
  getParentTaskInfo: (params: { parentTaskId: number; role?: UserRoleType }) => {
    return FastApiAxiosInstance.get<ParentTask>('/api/v2/task/getParentTaskInfo', {
      params,
    });
  },
  // 获取父任务下的需求方/审核方/制作方人员（仅需求方、审核方可调用），用于反馈 @ 提及
  getParentTaskRoleUsers: (params: { parentTaskId: number }) => {
    return FastApiAxiosInstance.get<ParentTaskRoleUser[]>('/api/v2/task/getParentTaskRoleUsers', {
      params,
    });
  },
  // 更新需求
  updateParentTask: (params: any) => {
    return FastApiAxiosInstance.post<{ parentTaskId: number }>('/api/v2/task/updateParentTask', params);
  },
  // 申请有灵推荐
  applyYLRecommend: (params: { parentTaskId: number }) => {
    return FastApiAxiosInstance.post('/api/v2/task/applyYLRecommend', params);
  },
};

export default taskV2;
